var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03757 5.9004C6.84262 5.70545 6.52557 5.70545 6.33063 5.9004C5.74579 6.48524 4.79269 6.48524 4.20778 5.9004L2.43945 4.13207C2.15589 3.84851 2.00032 3.47239 2.00032 3.07068C2.00032 2.66898 2.15588 2.29286 2.43945 2.0093C3.02429 1.42446 3.9754 1.42446 4.5623 2.0093L5.64928 3.09628C5.84423 3.29123 6.16128 3.29123 6.35623 3.09628C6.55117 2.90134 6.55117 2.58429 6.35623 2.38934L5.26924 1.30235C4.29449 0.327601 2.70728 0.327601 1.73254 1.30235C1.25994 1.77496 1 2.40115 1 3.07068C1 3.73823 1.25994 4.36641 1.73254 4.83901L3.50087 6.60734C3.98923 7.09374 4.62922 7.33791 5.2692 7.33791C5.90919 7.33791 6.54918 7.09374 7.03753 6.60734C7.23248 6.4124 7.23248 6.09535 7.03753 5.9004H7.03757Z",
    fill: "#2D338D",
    stroke: "#2D338D",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2711 6.30408L8.50273 4.53575C7.52798 3.561 5.94077 3.561 4.96603 4.53575C4.77109 4.7307 4.77109 5.04775 4.96603 5.24269C5.16098 5.43764 5.47803 5.43764 5.67298 5.24269C6.25782 4.65785 7.20893 4.65785 7.79582 5.24269L9.56415 7.01102C9.84771 7.29459 10.0033 7.67071 10.0033 8.07241C10.0033 8.47411 9.84772 8.85023 9.56415 9.1338C8.99703 9.70092 8.0085 9.70092 7.44131 9.1338L6.35628 8.04681C6.16133 7.85186 5.84428 7.85186 5.64934 8.04681C5.45439 8.24176 5.45439 8.5588 5.64934 8.75375L6.73633 9.83878C7.20893 10.3114 7.83711 10.5713 8.50466 10.5713C9.17221 10.5713 9.80038 10.3114 10.273 9.83878C10.7456 9.36617 11.0055 8.738 11.0055 8.07045C11.0036 7.4029 10.7436 6.7767 10.271 6.3041L10.2711 6.30408Z",
    fill: "#2D338D",
    stroke: "#2D338D",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLink);
export default __webpack_public_path__ + "static/media/active_link.01741a43e00640323d7cf5f80bc0e2ee.svg";
export { ForwardRef as ReactComponent };